import React, {Component} from 'react';


// UX 2.0: Client name moved to TopBar breadcrumb, no more big h1 title
export class ClientHeader extends Component {
    render() {
        return null;
    }
}